import { Injectable, WritableSignal, inject, signal } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, BehaviorSubject, ReplaySubject, throwError } from 'rxjs';
import { Global } from '@services/core/Global';
import { StorageService } from '@services/core/storage.service';

@Injectable({
    providedIn: 'root'
})

export class MicrosoftAuthService {
    private url;
    private url_back;
    public token: WritableSignal<string> = signal<string>(null)
    public refreshToken: WritableSignal<string> = signal<string>(null)
    public sharingRefreshToken = signal<string | undefined>(undefined)
    public sharingToken = signal<string | undefined>(undefined)

    storageService = inject(StorageService)

    constructor(
        private _http: HttpClient,
    ) {
        this.url = Global.url_api_auth
        this.url_back = Global.url_auth
    }



    getTokenAPI(promptLogin = false): Observable<any> {
        let headers = new HttpHeaders().set('Content-Type', 'application/json');
        const url = this.url + 'get-token' + (promptLogin ? '?prompt=login' : '');
        return this._http.get(url, { headers: headers });
    }

    getAccessToken(data): Observable<any> {
        //convertir el objeto del usuario a un JSON string
        let params = JSON.stringify({ code: data })
        let headers = new HttpHeaders().set('Content-Type', 'application/json');
        return this._http.post(this.url + "authorize-token", params, { headers: headers });
    }

    decryptToken(withMicrosoftToken = false): Observable<any> {
        let headers = new HttpHeaders().set('Content-Type', 'application/json');
        if (withMicrosoftToken) {
            const currentToken = this.token() || this.storageService.getJsonValue("token");
            if (currentToken) headers = headers.set('Authorization', currentToken);
        }
        return this._http.get(this.url_back + "decrypt-token", { headers: headers });
    }

    dropMicrosoftToken() {
        this.token.set(null);
        this.refreshToken.set(null);
        this.storageService.removeJsonValue('token');
        this.storageService.removeJsonValue('refresh_token');
    }

    checkSession(): Observable<any> {
        // Este endpoint valida la cookie HttpOnly en el backend
        return this._http.get(this.url_back + "check-session");
    }

    refreshTokenAPI(): Observable<any> {
        const refreshToken = this.refreshToken() ?? this.storageService.getJsonValue("refresh_token");
        if (!refreshToken) return throwError(() => new Error('No refresh token'));
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        return this._http.get(this.url + "refresh-token/" + refreshToken, { headers });
    }

    refreshFpvSession(): Observable<any> {
        return this._http.post(this.url_back + 'refresh-session', {});
    }

    logout(): Observable<any> {
        return this._http.get(this.url_back + "logout-session");

    }

    getPhoto(): Observable<any> {
        return this._http.get(this.url + "get-photo", { responseType: 'blob' });
    }

    getToken() {
        if (this.storageService.getJsonValue("token")) {
            this.token.set(this.storageService.getJsonValue("token"))
        }
        if (this.storageService.getJsonValue("refresh_token")) {
            this.refreshToken.set(this.storageService.getJsonValue("refresh_token"))
        }
    }

    clearSesion() {
        this.storageService.clearStorage()
    }


}

